import React from "react";
import { useTranslation } from "react-i18next";
import "./CampanaPropinaBlock.css";

/** Igual que el backend (src/api/campana/campana.input.js). */
export const CAMPANA_FRASES = ["gracias_equipo", "todo_buenisimo", "volveremos", "sois_geniales"];

/** Al activarla ya va con una frase marcada: un solo toque para el cliente. */
export const CAMPANA_INICIAL = { sonar: false, frase: "gracias_equipo" };

/**
 * "Haz sonar la campana del equipo": el cliente decide si al pagar suena la
 * campana en la barra y qué frase dice (de una lista; sin texto libre ni
 * importe). `value` / `onChange` con la forma de CAMPANA_INICIAL.
 */
const CampanaPropinaBlock = ({ value, onChange, accent = "#66bc5f" }) => {
  const { t } = useTranslation();
  const campana = value || CAMPANA_INICIAL;
  const set = (cambios) => onChange({ ...campana, ...cambios });

  return (
    <div className={`campana-block${campana.sonar ? " campana-block--on" : ""}`} style={{ "--campana-accent": accent }}>
      <button
        type="button"
        className="campana-block__toggle"
        aria-pressed={campana.sonar}
        onClick={() => set({ sonar: !campana.sonar })}
      >
        <span className="campana-block__bell" aria-hidden="true">🔔</span>
        <span className="campana-block__titles">
          <span className="campana-block__title">{t("campana.title")}</span>
          <span className="campana-block__subtitle">{t("campana.subtitle")}</span>
        </span>
        <span className="campana-block__switch" aria-hidden="true" />
      </button>

      {campana.sonar && (
        <div className="campana-block__body">
          <div className="campana-block__chips" role="group" aria-label={t("campana.frasesLabel")}>
            {CAMPANA_FRASES.map((frase) => (
              <button
                key={frase}
                type="button"
                className={`campana-block__chip${campana.frase === frase ? " is-selected" : ""}`}
                aria-pressed={campana.frase === frase}
                onClick={() => set({ frase: campana.frase === frase ? null : frase })}
              >
                {t(`campana.frases.${frase}`)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CampanaPropinaBlock;
